import React, {useEffect, Component, useState} from 'react'
import {connect} from "react-redux";
import {Link} from 'react-router-dom'
import {referenceActions} from "../../store/actions";
import moment from 'moment'
import ReferenceList from "./ReferenceList";
import ReferenceDetail from "./ReferenceDetail";
import history from "../../route/history";
const Reference = props => {

  const prePage = (e) => {
    e.preventDefault();
    window.history.back()
  }

    return(
      <React.Fragment>
        <div id="contents">
          <div className='content-header'>
            <a onClick={prePage} className="page-prev">뒤로이동</a> {/* mobile */}
            <h2>자료실</h2>
            <div className="breadcrumb">
              <span>Home</span><span>고객센터</span><em>자료실</em>
            </div>
          </div>

          <div className="notice-tab">
            <ul className='nav-tab mt40'>
                <li><Link title="공지사항" to="/notice">공지사항</Link></li>
                <li><Link title="FAQ" to="/faq">FAQ</Link></li>
                <li><Link title="문의하기" to="/question">문의하기</Link></li>
                <li className="on"><Link title="자료실" to="/reference">자료실</Link></li>
                <li><Link title="이용안내" to="/guide">이용안내</Link></li>
            </ul> 
          </div>
            {
              props.match.params.seq ?
              <ReferenceDetail seq={props.match.params.seq} searchInfo={props.location.state}/>
              : <ReferenceList search={props.location?.search} />
            }

            
        </div>
      </React.Fragment>
    )
  }



export default Reference